class SessionService {
  constructor ($cookies, $window, $q, $http, ngAuthSettings) {
    this.ngAuthSettings = ngAuthSettings;
    this.$cookies = $cookies;
    this.$q = $q;
    this.$http = $http;
    this.branches = null;
    this.models = [
      'contactEmail',
      'contactFirstName',
      'contactLastName',
      'contactName',
      'contactPosition',
      'firstname',
      'fullname',
      'isB2B',
      'isContactCenter',
      'isLogged',
      'applyLogisticsService',
      'isMaster',
      'isNatural',
      'isSupervisor',
      'paymentMethod',
      'isProvider',
      'isSeller',
      'operatingCenter',
      'operatingCenterId',
      'sellerExt',
      'sellerId',
      'thirdAttendantTypeId',
      'thirdAttendantTypeName',
      'thirdDocumentDV',
      'thirdDocumentNumber',
      'thirdDocumentTypeId',
      'thirdDocumentTypeName',
      'thirdId',
      'thirdName',
      'userId',
      'username',
      'phone',
      'payCart',
      'totalCartPay'
    ];
    this.store = $window.localStorage;
  }

  /**
   * @method get              Get akey value
   * @param  {string} key     Key to get
   */
  get(key) {
    if (key === 'globals') {
      this.getGlobals().then(response => {
        return response;
      });
    } else {
      let result = this.store.getItem(key);
      try {
        result = JSON.parse(result);
      } catch(e){}
      return result;
    }
  }

  /**
   * @method put              Set the key-value pair in the session
   * @param  {string} key     Key to set
   * @param  {object} value   Key value to set
   */
  put(key, value) {
    if (key === 'globals') {
      let currentUser = {};
      this.models.forEach(val => {
        if (value.currentUser) {
          currentUser[val] = value.currentUser[val];
        }
      });
      try {
        this.store.setItem('currentUser', JSON.stringify(currentUser));
      }
      catch (e) {
        this.store.setItem('currentUser', currentUser);
      }
      try {
        this.store.setItem('currentClient', JSON.stringify(value.currentClient));
      }
      catch (e) {
        this.store.setItem('currentClient', value.currentClient);
      }
    } else {
      try {
        this.store.setItem(key, JSON.stringify(value));
      }
      catch (e) {
        this.store.setItem(key, value);
      }
    }
  }

  /**
   * @method remove         Remove key from session
   * @param {string} key    Key to remove from session
   */
  remove(key) {
    if (key === 'globals') {
      this.store.removeItem('currentUser');
      this.store.removeItem('currentClient');
      
      // this.$cookies.remove('operatingCenters');
    } else {
      this.store.removeItem(key);
    }
  }

  getGlobals(){
    return this.$q((resolve, reject) => {
      let currentUser = this.store.getItem('currentUser'),
        currentClient = this.store.getItem('currentClient');
      try {
        currentUser = JSON.parse(currentUser);
      } catch(e){}
      try {
        currentClient = JSON.parse(currentClient);
      } catch(e){}
      if(currentUser && currentUser.userId){
        if(this.branches){
          currentUser['operatingCenters'] = this.branches;
          resolve({
            'currentUser': currentUser,
            'currentClient': currentClient
          });
        } else {
          this.$http({
            method: 'GET',//actionGetOperatingCentersByUserId
            url: this.ngAuthSettings.config.env.apiEndPoint  + '/login/get-operating-centers-by-user-id?userId=' + currentUser.userId,
            cache : false,
            headers: { 'Content-Type': 'application/json' }
          }).then(response => {
            currentUser['operatingCenters'] = response.data.data;
            this.branches = response.data.data;
            resolve({
              'currentUser': currentUser,
              'currentClient': currentClient
            });
          }).catch(reason => {
            resolve({
              'currentUser': currentUser,
              'currentClient': currentClient
            });
          });
        }

      } else {
        resolve({
          'currentUser': currentUser,
          'currentClient': currentClient
        });
      }

    });
  }
}

SessionService.$inject = ['$cookies', '$window', '$q', '$http', 'ngAuthSettings'];

export default SessionService;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/session/session.service.js
 **/